import React from "react";
import Main from "../components/main";

import Header from "../components/section/header";
import Footer from "../components/section/footer";
// import { localStorage } from "window-or-global";
// import { getCurrentUserQuery } from "../components/logic/user";
// import { useQuery } from "@apollo/client";
// import Loader from "../components/bootstrap/loader";
import "../style/custom/select-address.scss";
import AddressLocator from "../components/address-selector/index";
import { Col, Row } from "react-bootstrap";

import UserCheck from "../components/utils/user-check";

export default function SelectAddressPage(props) {
  return (
    <Main>
      <UserCheck>
        <UserSelectAddress {...props} />
      </UserCheck>
    </Main>
  );
}

const UserSelectAddress = () => {
  return (
    <Main>
      <Header />
      <div className="signup-page-container">
        <div className="signup-page-inner">
          <div className="section-1">
            <Row className="vw-fs">
              <Col lg={12} md={12} className="vw-fs-section">
                <div className="vw-su-panel">
                  <div className="vw-title">
                    {""}
                  </div>
                  <div className="vw-subtitle">
                    {""}
                  </div>

                  <div className="vw-sup-locator">
                    <AddressLocator
                      isWhite
                      inline
                      highlight
                      showLocator
                      onRequestClose={() => {}}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <Footer colour="black" />
        </div>
      </div>
    </Main>
  );
};
